import { debugConsoleLog } from 'utils/GeneralUtils';

type WebSocketLogAction = 'subscribed' | 'unsubscribed' | 'message';

export const websocketLog = (action: WebSocketLogAction, label: string, details?: Record<string, unknown>): void => {
    debugConsoleLog({
        action: `${label} ${action}`,
        ...details
    });
};
